// extracted by mini-css-extract-plugin
export default {"ReviewThreadContainer":"ReviewThread-module__ReviewThreadContainer__IxmRvoT"};